module.exports = __webpack_public_path__ + "media/images/games/k2gender/doctor-880e699932688151ce2f4442f08bfc0d.png";